import { tr } from 'i18n';
export const REPORT_STAGES = [
  { key: 'entered', api: 'entered', label: "Въезд", color: "var(--theme-primary-text, #0d00f3)" },
  { key: 'queued', api: 'queued', label: "В очереди", color: "var(--theme-info-text, #a3b8d5)" },
  { key: 'repair', api: 'repair', label: "На ремонте", color: "var(--theme-danger-text, #c88f9b)" },
  { key: 'loading', api: 'in_loading', label: "В погрузке", color: "var(--theme-warning-text, #c6933d)" },
  { key: 'route', api: 'in_route', label: "В пути", color: "var(--theme-primary-text, #0d00f3)" },
  { key: 'completed', api: 'completed', label: "Завершено", color: "var(--theme-success-text, #238268)" },
]

export const reportStageTotal = source => REPORT_STAGES.reduce((sum, stage) => sum + Number(source?.[stage.api] ?? source?.[stage.key] ?? 0), 0)
export const reportBase = base => ({ name: base.name, ...Object.fromEntries(REPORT_STAGES.map(stage => [stage.key, Number(base[stage.api] ?? 0)])) })
